import isBrowser from '../isBrowser'

const isReactNative = () => {
  if (!!isBrowser()) {
    return window?.navigator?.product === 'ReactNative'
  }

  return false
}

export default isReactNative
